import { useCallback, useRef } from 'react';

import { TooltipHover, Tag, BottomSheet, useBreakpoint } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import useToggleState from 'src/hooks/useToggleState';

const TrlKeys = {
    label: 'relatedProfession.label',
    hover: 'relatedProfession.hover',
};

const RelatedProfessionTag: TranslatedComponent<{ showHover?: boolean }> = ({ trls, showHover = true }) => {
    const activatorRef = useRef<HTMLSpanElement>(null);

    const [isBsVisible, toggleBsVisibility] = useToggleState(false);
    const { isMobile } = useBreakpoint();
    const toggleBottomSheet = useCallback(() => isMobile && toggleBsVisibility(), [isMobile, toggleBsVisibility]);

    return (
        <>
            <span onClick={toggleBottomSheet} data-interactive ref={activatorRef}>
                <Tag style="special">{trls[TrlKeys.label]}</Tag>
            </span>
            {showHover &&
                (isMobile ? (
                    <BottomSheet visible={isBsVisible} onClose={toggleBottomSheet}>
                        {trls[TrlKeys.hover]}
                    </BottomSheet>
                ) : (
                    <TooltipHover placement="top-center" activatorRef={activatorRef}>
                        {trls[TrlKeys.hover]}
                    </TooltipHover>
                ))}
        </>
    );
};

export default translation(RelatedProfessionTag);
